import * as ActionTypes from './actionTypes.js';

const INITIAL_STATE = {
    agentSiteCreateProgress: false,
    agentSiteCreateFailure: false,
    agentSiteCreateSuccess: false,
    agentSiteDeleteProgress: false,
    agentSiteDeleteFailure: false,
    agentSiteDeleteSuccess: false,
    siteListErrorMessage: '',
    agentSiteFetchError: false,
    isNextPageLoading: true, 
    siteIdAvailable: true
};

/**
* @param {Object} state - Default application state
* @param {Object} action - Action from action creator
* @returns {Object} New state
*/
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_SITE_LIST_SUCCESS:
            const { siteList } = action;
            return Object.assign({}, INITIAL_STATE, { siteList, agentSiteFetchError: false });

        case ActionTypes.CREATE_AGENT_SITE_SUCCESS:
            return Object.assign({}, state, action.payload);

        case ActionTypes.DELETE_AGENT_SITE_PROGRESS:
            return Object.assign({}, state, {
                agentSiteDeleteProgress: true,
                agentSiteDeleteFailure: false,
                agentSiteDeleteSuccess: false
            });

        case ActionTypes.CREATE_AGENT_SITE_FAILURE:
        return Object.assign({}, state, {
            agentSiteCreateProgress: false,
            agentSiteCreateFailure: true,
            agentSiteCreateSuccess: false
        });

        case ActionTypes.DELETE_AGENT_SITE_SUCCESS:
        return Object.assign({}, state, {
            agentSiteDeleteProgress: false,
            agentSiteDeleteFailure: false,
            agentSiteDeleteSuccess: true
        });

        case ActionTypes.FETCH_SITE_LIST_FAILURE: 
        let errorObj = action.error;
            return Object.assign({}, state, {
                siteListErrorMessage: errorObj.error.message,
                agentSiteFetchError: true,
                siteList: []
            });

        case ActionTypes.SHOW_PAGINATION_PROGRESS:
        const isNextPageLoading = action.payload.isNextPageLoading;
        return Object.assign({}, state, {isNextPageLoading, agentSiteFetchError: false});
        
        case ActionTypes.VALIDATE_SITEID: 
        return Object.assign({}, status, {...action.payload});
        default: return state;
    }
};
